import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useStytch, useStytchSession } from '@stytch/react';
import { useDispatch } from 'react-redux';
import { Text } from '../../components/Typography/Typography';
import { fetchCurrentUser } from '../../store/user/slice';
import { AppDispatch } from '../../store';
import styles from './AuthenticatePage.module.scss';

const AuthenticatePage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { session } = useStytchSession();
  const stytch = useStytch();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const hasAttemptedAuth = useRef(false);

  useEffect(() => {
    const authenticateAndRedirect = async () => {
      try {
        if (session) {
          await dispatch(fetchCurrentUser());
          navigate('/');
          return;
        }

        const token = searchParams.get('token');
        const tokenType = searchParams.get('stytch_token_type');

        if (token && tokenType && !hasAttemptedAuth.current) {
          hasAttemptedAuth.current = true;

          if (tokenType === 'magic_links') {
            try {
              await stytch.magicLinks.authenticate(token, {
                session_duration_minutes: 60 * 24 * 7, // 7 days
              });
            } catch (error) {
              console.error('Magic link authentication failed:', error);
              throw error;
            }
          } else if (tokenType === 'oauth') {
            await stytch.oauth.authenticate(token, {
              session_duration_minutes: 60 * 24 * 7, // 7 days
            });
          } else {
            throw new Error(`Unsupported token type: ${tokenType}`);
          }
        } else if (!token || !tokenType) {
          navigate('/login');
        }
      } catch (error) {
        console.error('Authentication error:', error);
        navigate('/login');
      }
    };

    authenticateAndRedirect();
  }, [searchParams, session, stytch, navigate, dispatch]);

  return (
    <div className={styles.container}>
      <Text size="large" weight="medium">
        Authenticating...
      </Text>
    </div>
  );
};

export default AuthenticatePage;
